import { useCallback, useEffect, useState } from "react";
import { listPaymentRequests } from "../api/listPaymentRequests";
import { PaymentRequest, PaymentRequestStatus } from "../types/paymentRequest";

interface UsePaymentRequestsOptions {
  sessionUuid?: string;
  initialStatus?: PaymentRequestStatus;
}

export function usePaymentRequests(options: UsePaymentRequestsOptions = {}) {
  const { sessionUuid, initialStatus } = options;
  const [paymentRequests, setPaymentRequests] = useState<PaymentRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<PaymentRequestStatus | undefined>(
    initialStatus,
  );

  const refetch = useCallback(() => {
    setLoading(true);
    setError(null);
    listPaymentRequests({ status, sessionUuid })
      .then((res) => setPaymentRequests(res.paymentRequests))
      .catch((e) =>
        setError(
          e instanceof Error ? e.message : "Could not load payment requests.",
        ),
      )
      .finally(() => setLoading(false));
  }, [status, sessionUuid]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    paymentRequests,
    loading,
    error,
    status,
    setStatus,
    refetch,
  };
}
